import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/hooks/useAuth";
import { useProfile } from "@/hooks/useProfile";
import { friendlyAuthError } from "@/lib/errors";
import { ROUTES } from "@/constants/routes";

const initials = (name, email) =>
  (name || email || "?").split(/\s+/).filter(Boolean).slice(0, 2).map((p) => p[0].toUpperCase()).join("");

export function UserArea({ idPrefix = "" }) {
  const { signOut } = useAuth();
  const { profile } = useProfile();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  const handleLogout = async () => {
    setBusy(true);
    try {
      await signOut();
      navigate(ROUTES.login, { replace: true });
    } catch (err) {
      toast.error(friendlyAuthError(err));
      setBusy(false);
    }
  };

  return (
    <div data-testid={`${idPrefix}user-menu`} className="border-t border-white/10 pt-5">
      <div className="flex items-center gap-3 px-2">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md border border-white/15 font-mono text-xs text-zinc-200">
          {initials(profile?.full_name, profile?.email)}
        </span>
        <div className="min-w-0">
          <p data-testid={`${idPrefix}user-name`} className="truncate text-sm font-medium text-zinc-100">{profile?.full_name || "Your name"}</p>
          <p data-testid={`${idPrefix}user-email`} className="truncate text-xs text-zinc-500">{profile?.email}</p>
        </div>
      </div>
      <button type="button" onClick={handleLogout} disabled={busy} data-testid={`${idPrefix}logout-button`} className="mt-4 flex w-full items-center gap-3 rounded-md px-3 py-2.5 text-sm text-zinc-400 transition-colors hover:bg-white/[0.04] hover:text-zinc-100 disabled:opacity-50">
        <LogOut className="h-4 w-4" aria-hidden="true" />
        {busy ? "Signing out" : "Log out"}
      </button>
    </div>
  );
}
